import { useMemo } from "react";
import { useEventSafe } from "../context/EventContext";
import {
  generateColorPalette,
  applyThemeColors,
  getThemeColorClasses,
  getThemeColorStyles,
} from "../lib/themeColors";

/**
 * Custom hook for accessing theme colors
 * @returns {object} Theme color utilities and palette
 */
export function useThemeColors() {
  const { event } = useEventSafe();
  const themeColor = event?.theme_color;

  const palette = useMemo(() => {
    return generateColorPalette(themeColor);
  }, [themeColor]);

  const colorClasses = useMemo(() => {
    return getThemeColorClasses(themeColor);
  }, [themeColor]);

  const colorStyles = useMemo(() => {
    return getThemeColorStyles(themeColor);
  }, [themeColor]);

  // Apply theme colors to document when theme color changes
  useMemo(() => {
    if (themeColor) {
      applyThemeColors(themeColor);
    }
  }, [themeColor]);

  return {
    themeColor,
    palette,
    colorClasses,
    colorStyles,
    applyThemeColors: () => applyThemeColors(themeColor),
  };
}
